import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'hvac-delete-account-page',
    templateUrl: './delete-account-page.component.html',
    styleUrls: ['./delete-account-page.component.scss']
})
export class DeleteAccountPageComponent implements OnInit {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ngOnInit(): void {
    }
}
